// Override Settings  product.images.size > 1 
var webyzeSwathesToLoad = [];
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        productAndVariantAvailable: true
    },
    selector: {
        products: '#product-loop'
    }
};

var __bcSfFilterTransport = {};

var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale-item">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelHtml': '<div class="so-item">' + bcSfFilterConfig.label.sold_out + '</div>',
    'newLabelHtml': '<div class="new-item">' + bcSfFilterConfig.label.new + '</div>',
    'bisLabelHtml': '<div class="best-item">Best Seller</div>',
    'vendorHtml': '<h4>{{itemVendorLabel}}<h4>',
    'filterOptionLabel': '{{itemValue}} {{itemAmount}}',
  'filterOptionSwatchHtml': '<label class="visuallyhidden" for="layered_filter-1-color2">Colors</label><select class="bc-sf-filter-option-swatch {{swatchStyle}}" id="layered_filter-1-color2">{{itemList}}</select>',
    'filterOptionSwatchItem': '<option data-link="{{itemLink}}" data-click="{{itemFunc}}" value="{{itemTitle}}">{{itemLabel}}</option>',
  'quickViewHtml': '<a title="Quick View {{itemTitle}}" class="fancybox.ajax product-modal" href="{{itemUrl}}?view=quick" aria-label="Quick View {{itemTitle}} {{itemId}}">' + bcSfFilterConfig.label.quick_view + '</a>',

    'productGridItemHtml':  '<div id="product-listing-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
                                '<div class="product-index-inner"><div class="product__badges">' +
                                    '{{itemNewLabel}}' +
                                    '{{itemBisLabel}}' +
                                    '{{itemSaleLabel}}' +
                                '</div></div>' +
                                '<div class="prod-image">' +
                                    '{{itemEaBadge}}' +
                                    '<a href="{{itemUrl}}" title="{{itemTitle}}" aria-label="{{itemTitle}} {{itemId}}">' +
                                        '<div class="reveal">' +
                                            '{{itemThumb}}' +
                                            '{{itemFlipImage}}' +
                                        '</div>' +
                                    '</a>' +
                                    '{{itemQuickView}}' +
                                '</div>' +
                                '<div class="product-info">' +
                                    '<div class="product-info-inner">' +
                                        '{{itemSwatch}}' +
                                        '<a href="{{itemUrl}}" aria-label="{{itemTitle}} {{itemId}}">' +
                                            '{{itemVendor}}' +
                                            '<span class="prod-title">{{itemTitle}}</span>' +
                                        '</a>' +
                                        '<div class="price">{{itemPrice}}</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<div class="pagiprev"><a href="{{itemUrl}}" title="" aria-label="Previous"><i class="fa fa-caret-left"></i></a></div>',
    'nextHtml': '<div class="paginext"><a href="{{itemUrl}}" title="" aria-label="Next"><i class="fa fa-caret-right"></i></a></div>',
    'pageItemHtml': '<a href="{{itemUrl}}" title="">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '{{itemTitle}}',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
    'paginateTopHtml': '{{previous}} <span class="pagination-count"></span> {{next}}',
  
    // Sorting Template
    'sortingHtml': '<select class="styled-select" aria-label="Sort By">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;

    var getImageByPosition = function (imageStore, position, key) {
		var key = key || 'position',
            out = null;
        if (typeof imageStore === 'object') {
          for (var i = 0; i < imageStore.length; i++) {
            if (parseInt(imageStore[i][key]) === parseInt(position)) {
              out = imageStore[i];
              break;
            }
          }
        }
      	return out;
    }
  
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '' && data.variants) {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add itemGridWidthClass
    var itemGridWidthClass = '';
    var productsPerRow = bcSfFilterConfig.custom.products_per_row;
    switch (productsPerRow) {
        case 6: itemGridWidthClass = buildItemGridClass('desktop-2', index, productsPerRow); break;
        case 4: itemGridWidthClass = buildItemGridClass('desktop-3', index, productsPerRow); break;
        case 3: itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow); break;
        case 5: itemGridWidthClass = buildItemGridClass('desktop-fifth', index, productsPerRow); break;
        case 2:  itemGridWidthClass = buildItemGridClass('desktop-6', index, productsPerRow); break;
        default: break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Label
    var itemNewLabelHtml = '';
    var itemSaleLabelHtml = '';
    var itemBisLabelHtml = '';

    var excludedCollections = [
      '/collections/womens-clothing-new-arrivals',
      '/collections/womens-tops-new-arrivals',
      '/collections/new-arrivals-accessories',
      '/collections/sympli-clothing-new-arrivals',
      '/collections/planet-clothing-new-arrivals',
      '/collections/womens-bottoms-pants-shorts-new-arrivals',
    ];
    var currentPath = window.location.pathname;

    if (!soldOut) {
      var isNew = false,
          isBest = false;

      data.tags.forEach((tag) => {
        if (tag.includes('date:') && !excludedCollections.some(path => currentPath.includes(path))) {
          isNew = true;
        }
      })

      data.tags.forEach((tag) => {
        if (tag.includes('bestseller:') && !currentPath.includes('/collections/best-sellers')) {
          isBest = true;
        }
      })

      if (isBest) {
        itemBisLabelHtml = bcSfFilterTemplate.bisLabelHtml;
      } else if (isNew) {
        itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
      }

      if (onSale) {
          itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml.replace(/{{itemOldPrice}}/g, this.formatMoney(data.price_min, this.moneyFormat));
      }
    }

    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
    itemHtml = itemHtml.replace(/{{itemBisLabel}}/g, itemBisLabelHtml);
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // EA promo badge (tag-driven) — mirrors snippets/ea-image-badges.liquid so the
    // badge survives the client-side re-render of the grid by Boost SF Filter.
    var itemEaBadgeHtml = '';
    var eaBadgeText = '';
    var eaBadgeExpires = '';
    (data.tags || []).forEach(function (tag) {
        // check 'badge-expires:' BEFORE 'badge:' — keep the else-if precedence
        if (tag.indexOf('badge-expires:') > -1) {
            eaBadgeExpires = tag.replace('badge-expires:', '').trim();
        } else if (tag.indexOf('badge:') > -1) {
            eaBadgeText = tag.replace('badge:', '').trim();
        }
    });
    var showEaBadge = true;
    if (eaBadgeExpires) {
        // end-of-day expiry; parsed in the shopper's local time
        var eaExpiryTs = Date.parse(eaBadgeExpires + 'T23:59:59');
        if (!isNaN(eaExpiryTs) && Date.now() > eaExpiryTs) {
            showEaBadge = false;
        }
    }
    if (showEaBadge && eaBadgeText) {
        var eaStyle = window.eaBadgeStyle || {};
        var eaShape = eaStyle.shape || 'ribbon';
        var eaPosition = eaStyle.position || 'top-left';
        var eaBg = eaStyle.background_color || '#2f2a6b';
        var eaFg = eaStyle.text_color || '#ffffff';
        var eaHasBorder = !!eaStyle.show_border;
        var eaBorderColor = eaStyle.border_color || eaFg;
        var eaEscape = function (s) {
            return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        };
        var eaStyleAttr = '--ea-bg:' + eaBg + ';--ea-fg:' + eaFg + ';' + (eaHasBorder ? ('--ea-bc:' + eaBorderColor + ';') : '');
        var eaBorderClass = eaHasBorder ? ' ea-badge--border' : '';
        itemEaBadgeHtml = '<div class="ea-badge ea-badge--' + eaShape + ' ea-badge--pos-' + eaPosition + eaBorderClass + '"' +
            ' style="' + eaStyleAttr + '">' +
            '<div class="ea-badge__content"><div class="ea-badge__text">' + eaEscape(eaBadgeText) + '</div></div>' +
            '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemEaBadge}}/g, itemEaBadgeHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
        itemPriceHtml += '<div class="was">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>';
    } else {
        itemPriceHtml += '<div class="prod-price">';
        if (priceVaries) {
            itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
        } else {
            itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        }
        itemPriceHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Thumbnail & Flip Image
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;
    var firstImageCLass = bcSfFilterConfig.custom.image_flip && images.length > 1 ? 'first-image' : '';
    var itemThumbHtml = '<img ' + firstImageCLass + ' src="' + itemThumbUrl + '" alt="{{itemTitle}}" data-original="' + itemThumbUrl + '" />';
    var itemFlipImageHtml = '';
    if (bcSfFilterConfig.custom.image_flip && images.length > 1) {
        itemFlipImageHtml = '<div class="hidden"><img src="' + this.optimizeImage(images[1]['src'], '500x') + '" alt="{{itemTitle}}" /></div>';
    }
    itemHtml = itemHtml.replace(/{{itemThumb}}/g, itemThumbHtml);
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImageHtml);

    // Add Quick view
    var itemQuickViewHtml = bcSfFilterConfig.custom.quick_view_enable ? bcSfFilterTemplate.quickViewHtml : '';
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

  
    // Add Swatches
    var itemSwatchHtml = '';
    /*if (bcSfFilterConfig.custom.alternate_colors && data.images.length > 0) {
        __bcSfFilterTransport[data.id] = {
          optionId: null,
          values: []
        };
      
        for (var k = 0; k < data.options_with_values.length; k++) {
            var option = data['options_with_values'][k]['name'];
            var option_handle = this.slugify(option);
            var option_index = k;

            var is_color = false;
            var downcased_option = option.toLowerCase();
            if (downcased_option.indexOf('color') > -1 || downcased_option.indexOf('colour') > -1) {
                itemSwatchHtml += '<div class="prod-colors"><div class="col-swatch"><label class="visuallyhidden" for="collection_swatches-{{itemId}}-color{{___INDEX___}}">Colors</label>'.replace('{{___INDEX___}}', 2);
                itemSwatchHtml += '<select class="collection___swatches" id="collection_swatches-{{itemId}}-color{{___INDEX___}}">'.replace('{{___INDEX___}}', 2);
              	__bcSfFilterTransport[data.id].optionId = option_index;
              
              	var values = '';
                var optionValues = data['options_with_values'][k]['values'];
                
              	for (var i = 0; i < optionValues.length; i++) {
                    var value = optionValues[i]['title'];
                    var wrapped_value = ',' + value + ',';
                    if (values.indexOf(wrapped_value) == -1) {
                        var variantImage = bcSfFilterConfig.general.no_image_url;
                        
                      	var imageIndex = optionValues[i]['image'],
                      		imageData = getImageByPosition(images, imageIndex);
                        if (imageData) {
                          if (typeof imageData.src !== 'undefined') {
                          	  variantImage = this.optimizeImage(imageData.src);
                          }
                        }
                        var fileColorUrl = bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', this.slugify(value) + '.png');
                        itemSwatchHtml += '<option value="' + value + '" data-href="' + variantImage + '">' + value + '</option>';
                        values += values + wrapped_value;
                      __bcSfFilterTransport[data.id].values.push(value);
                    }
                }

                itemSwatchHtml += '</select>';
              
                itemSwatchHtml += '<ul data-option-index="' + option_index + '" class="' + option_handle + ' options">';
                var values = '';
                var optionValues = data['options_with_values'][k]['values'];
              
                for (var i = 0; i < optionValues.length; i++) {
                    var value = optionValues[i]['title'];
                    var wrapped_value = ',' + value + ',';
                    if (values.indexOf(wrapped_value) == -1) {
                        var variantImage = bcSfFilterConfig.general.no_image_url;
                        
                        var imageIndex = optionValues[i]['image'],
                              imageData = getImageByPosition(images, imageIndex);
                          if (imageData) {
                            if (typeof imageData.src !== 'undefined') {
                                variantImage = this.optimizeImage(imageData.src);
                            }
                          }
                        var fileColorUrl = bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', this.slugify(value) + '.png');
                        itemSwatchHtml += '<li data-option-title="' + value + '" data-href="' + variantImage + '" class="color ' + this.slugify(value) + '">';
                        itemSwatchHtml += '<span style="background-color: ' + this.slugify(value.split(' ').pop()) + '; background-image: url(' + fileColorUrl + ')"></span>';
                        itemSwatchHtml += '</li>';
                        values += values + wrapped_value;
                    }
                }
                itemSwatchHtml += '</ul>';
                itemSwatchHtml += '</div></div>';
            }
        }
      if (bcSfFilterConfig.custom.image_flip == true) {
            itemSwatchHtml +=   '<script>' +
                                    "$('#product-listing-{{itemId}} .col-swatch li').each(function(){" +
                                        "var Original = $('#product-listing-{{itemId}} .prod-image img').attr('data-original'); " +
                                        "$(this).hover(function() {" +
                                            "var newImage = $(this).attr('data-href');" +         
                                            "$( '#product-listing-{{itemId}} .prod-image img' ).attr({ src: newImage }); " +
                                            "return false; " +         
                                        "}, function(){";
                                              if (bcSfFilterConfig.custom.image_flip_permanent == false) {
                                            	itemSwatchHtml += "$('#product-listing-{{itemId}} .prod-image img' ).attr({ src: Original });";
                                              }
              								
                    					itemSwatchHtml += "});" +
                                    "});" +
                                '</script>';
      }
    }*/

  
const optionNames = ["color", "colour", "colors", "colours", "material", "materials", "fabric", "fabric", "finish", "farbe", "farve", "färg", "farge"].map(name => name.toLowerCase());
data.options.forEach((opt, opt_index) => {
  const opt_name = opt.toLowerCase();
  if (optionNames.includes(opt_name)) {
    // Only build swatches for option values that still have at least one purchasable variant,
    // so colors that were sold out / hidden don't show up on the collection grid.
    // Nothing available at all means no swatches for this product.
    let swatch_variants = data.variants.filter(vari => vari.available);
    if (swatch_variants.length == 0) return;
    let swatch_list = swatch_variants.map(vari => encodeURIComponent(vari.options[opt_index])).join("|^|");
    itemSwatchHtml += `<div class="collectionSwatches" data-id="${data.id}"></div>`;
    webyzeSwathesToLoad.push({
      id          : data.id,
      index       : opt_index,
      product     : data,
      swatchNames : swatch_list,
    });
  }
});

  
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, this.formatMoney(data.price_min, this.moneyFormat));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariant.id);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  
    return itemHtml;
}

function buildItemGridClass(itemClass, index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 1) { itemClass += ' first'; }
    else if (temp == 0) { itemClass += ' last'; };
    return itemClass;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;
        var paginationTopHtml = bcSfFilterTemplate.paginateTopHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        paginationTopHtml = paginationTopHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        paginationTopHtml = paginationTopHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
    // Build Total Products
    if (this.getSettingValue('general.paginationType') == 'default') {
        var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
        var to = from + data.products.length - 1;
        jQ('#pagination').find('.count').html(bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' +  bcSfFilterConfig.label.pagination_of + ' ' + data.total_product);

        // Build Top Pagination info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
        jQ('#bc-sf-filter-top-pagination').find('.pagination-count').html(currentPage + ' ' + bcSfFilterConfig.label.pagination_of + ' ' + totalPage + ' ');
    } else {
        jQ('#pagination').hide();
        jQ('#bc-sf-filter-top-pagination').hide();
    }
};

// Show Filter Tree on Mobile
BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var _this = this;
    jQ(this.selector.filterTreeMobileButton).on('click', function() {
        jQ('#sidebar').slideToggle();
        // Re-initialize jscrollpane
        _this.buildFilterScrollbar();
    });
}

BCSfFilter.prototype.buildFilterOptionSwatch = function(a, b) {
    a.hasOwnProperty("values") && ("all" == a.valueType || this.getSettingValue("general.sortManualValues") || "all" != a.valueType && a.sortManualValues) && (a.values = this.sortFilterOptionValue(a));
    var c = ""
      , d = a.filterType
      , e = a.displayType
      , f = a.selectType
      , g = a.filterOptionId
      , h = a.label;
    for (var i in a.values)
        c += this.buildFilterOptionSwatchData(d, g, h, e, f, a.values[i], a);
    if ("" != c) {
        var j = bcSfFilterTemplate.filterOptionSwatchHtml;
        j = j.replace(/{{swatchStyle}}/g, this.buildSwatchStyle(a)),
        j = j.replace(/{{itemList}}/g, c),
        this.buildFilterOption(j, a, b)
    }
}
function loadSwatchesScript(src, eventType, data){
      try {
        var script = document.createElement("script");
        var script_date = (new Date).getTime();
        var retries = 0;
        
        data = data || [];
        
        data = [src].concat(data);

        script.type = "text/javascript";
        script.src = src;
        script.id = "bc-sf-filter-script-swatches";
        script.async = true;
        
        script.addEventListener("error", function(d) {
          "function" == typeof document.getElementById(script.id).remove ? document.getElementById(script.id).remove() : document.getElementById(script.id).outerHTML = "";
          jQ(document).trigger(eventType + 'Failed' || 'swatchJsFailed', data);
        });

        document.getElementsByTagName("head")[0].appendChild(script);

        script.onload = function() {
          "function" == typeof document.getElementById(script.id).remove ? document.getElementById(script.id).remove() : document.getElementById(script.id).outerHTML = "";
          jQ(document).trigger(eventType + 'Loaded' || 'swatchJsLoaded', data);
        }
      } catch(e) { console.error(e); }
}

BCSfFilter.prototype.buildAll = function (buildAll) {
    return function () {
      
      jQ(document).one('filterLoaded', function(e) {
        setTimeout(function(){
          /*jQ('#webyzeSwatches_1_2').closest('.bc-sf-filter-block-content').jScrollPane({
            contentWidth :275
          });*/
        }, 200); // Timeout to overcome internal check by swatches on load event.
      });
      __bcSfFilterTransport = {};
      
      var result = buildAll.apply(this, arguments);

      setTimeout(()=>{
        
        webyzeSwathesToLoad.forEach((s)=>{
          window.loadSwatchesCollection(s);
        });
        webyzeSwathesToLoad = [];
      }, 400);
      
      return result;
    };
}(BCSfFilter.prototype.buildAll);


BCSfFilter.prototype.buildProductListData = function (buildProductListData) {
    return function () {      	
        var result = buildProductListData.apply(this, arguments);
        var products = (typeof arguments[0] === 'object') ? arguments[0] : null, productSku = {};
        if (products) {
          products.forEach(function (one) {
              productSku[one.id] = one.handle;
          });
        }
      /*
      jQ(document).off('.collectionSwatch').on('collectionItemLoaded.collectionSwatch', function(event, url, productId, optionId){
        setTimeout(function(){
          var amountOfShownItems = 5;
          //var swatchesContainer = jQ('#webyzeSwatches_'+productId+'_'+optionId);
          var swatchesList = swatchesContainer.find('.swatchColor'), toggleAbleSwatches, toggler;
          
          if(swatchesList.length > amountOfShownItems) {
            toggleAbleSwatches = swatchesList.filter(':gt(' + (amountOfShownItems - 1) +')');
			toggleAbleSwatches.hide();
            
            swatchesContainer.append(jQ('<a>', {'class': 'show__more', 'text': 'Show More...', 'title': 'Show more choices'}));
                                     
            toggler = swatchesContainer.find('.show__more');
                                     
            swatchesContainer.on('click.showMore', 'a.show__more', function(e) {
              e.preventDefault();
              toggleAbleSwatches.toggle();
              toggler.text('Show ' + (toggleAbleSwatches.is(':visible') ? 'Less': 'More')  + '...');
            }); 
          }
          jQ('#webyzeSwatches_1_2>.swatchColor').on('click', function(){
                    window.location = jQ( '#webyzeSwatches_1_2' ).prev().find( 'option[data-title="'+ jQ( this ).data('name') +'"]' ).data('link');
                } );
          jQ('#webyzeSwatches_'+productId+'_'+optionId+' .swatchColor').each(function(){
            var self = $(this);
            var Original = $('#product-listing-'+ productId +' .prod-image img[data-original]').attr('data-original');
            var _optionIndex = self.closest('.col-swatch').find('ul.options').attr('data-option-index');
            if (typeof productSku[productId] !== 'undefined') {
          		self.closest('.col-swatch').find('.collection___swatches').attr('data-target', productSku[productId]+'_'+_optionIndex);
              	var selectedValue = localStorage.getItem(productSku[productId]+'_'+_optionIndex); 
              
              	var selectElement = self.closest('.col-swatch').find('.collection___swatches');
                if (selectedValue) {
					selectElement.find('option[value="'+selectedValue+'"]').prop('selected', true);
              		selectElement.trigger('change');
                }
              	//localStorage.setItem(productSku[productId]+'_'+_optionIndex, null);  
          	}
            self.hover(function() {
              var selectElement = self.closest('.col-swatch').find('.collection___swatches');
              selectElement.find('option[value="'+self.attr('data-name')+'"]').prop('selected', true);
              selectElement.trigger('change');
              
              if (typeof productSku[productId] !== 'undefined') {
              	localStorage.setItem(productSku[productId]+'_'+_optionIndex, self.attr('data-name'));  
              }
            }, function(){
              if (bcSfFilterConfig.custom.image_flip_permanent == false) {
                $('#product-listing-'+ productId +' .prod-image img').attr({ src: Original });
              }
            });
          });
          
        }, 500); // Timeout to overcome internal check by swatches on load event.
      })
	
      $.each(arguments[0], function(i,productData){
        $('#product-listing-'+ productData.id +' .col-swatch').each(function(){
          var additionalRequestParams = productData.id + '|2|' + __bcSfFilterTransport[productData.id].values.join('|').replaceAll(' ', '+');
          
          loadSwatchesScript(___transportUrlCollection + additionalRequestParams, 'collectionItem', [productData.id, 2]);
        });
      });

      $(document).off('.collectionSwatch').on('change.collectionSwatch', '.collection___swatches', function(){
        var originalImageInstance = $(this).closest('.product-index').find('img[data-original]');
        
		originalImageInstance.attr('src', $(this).find(':selected').attr('data-href'));
      });*/
      
      $(document).trigger('allProductItemsLoaded');
      
      return result;
    };
}(BCSfFilter.prototype.buildProductListData);

BCSfFilter.prototype.buildFilterOptionLabel = function(a, b, c) {
    a = this.customizeFilterOptionLabel(a, c.prefix, c.filterType);
    var d = bcSfFilterTemplate.filterOptionLabel.replace(/{{itemValue}}/g, a);
    return this.getSettingValue("general.showFilterOptionCount") && "box" != c.displayType && !0 !== c.keepValuesStatic && null !== b && (b > 0 && 0 == this.getSettingValue("general.showOutOfStockOption") || 1 == this.getSettingValue("general.showOutOfStockOption")) ? d.replace(/{{itemAmount}}/g, "(" + b + ")") : d.replace(/{{itemAmount}}/g, "")
}

BCSfFilter.prototype.buildFilterOptionSwatchData = function(a, b, c, d, e, f, g) {
  
    if (this.checkShowFilterOptionItem(f, g)) {
        var h = f.key
          , i = f.key
          , j = i;
        "collection" == a && (h = f.label,
        i = f.handle,
        j = h);
        var k = this.getSettingValue("general.colorOptionsArr")
          , l = b.replace("pf_t_", "").replace("pf_opt_", "");
        if ("" != k) {
            void 0 !== k.filter(function(a) {
                return b.indexOf(a) > -1
            })[0] && (l = "color")
        }
        j = this.customizeSwatchFileName(j, f, g);
        var m = bcSfFilterTemplate.filterOptionSwatchItem;
        m = this.buildFilterOptionItem(m, h, i, a, b, c, d, e, f, g);
        var n = getFilePath(l + "-" + j, this.swatchExtension, this.getSettingValue("general.swatchImageVersion"));
        m = m.replace(/{{itemImageValue}}/g, n);
        var o = g.hasOwnProperty("borderSwatch") && "" != g.borderSwatch ? g.borderSwatch : "none";
        return m = m.replace(/{{itemBorder}}/g, o)
    }
    return ""
}

BCSfFilter.prototype.buildFilterOptionItem = function(a, b, c, d, e, f, g, h, i, j) {

    var k = !!j.hasOwnProperty("keepValuesStatic") && j.keepValuesStatic;
    if ("review_ratings" == d && "text" == this.getSettingValue("general.ratingSelectionStyle"))
        var l = this.getReviewRatingsLabel(i.from);
    else
        var l = this.customizeFilterOptionLabel(b, j.prefix, d);
    if (!0 === k)
        var m = null;
    else
        var m = i.hasOwnProperty("doc_count") ? i.doc_count : 0;
    a = a.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(b, m, j)),
    a = a.replace(/{{itemLink}}/g, this.buildFilterOptionLink(e, c, d, g, h, k)),
    a = a.replace(/{{itemValue}}/g, encodeURIParamValue(c)),
    a = a.replace(/{{itemTitle}}/g, l),
    a = a.replace(/{{itemFunc}}/g, "onInteractWithFilterOptionValue(event, this, '" + d + "', '" + g + "', '" + h + "', '" + k + "')"),
    a = this.checkFilterOptionSelected(e, c, d, g) ? a.replace(/{{itemSelected}}/g, "selected") : a.replace(/{{itemSelected}}/g, "");
    var n = jQ(a);
    //if (d === 'tag' || d === 'opt_size') {
		n.find('a').attr({
        "data-id": e,
        "data-value": encodeURIParamValue("collection" == d ? c.split(":")[0] : c),
        "data-parent-label": f,
        "data-title": l,
        "data-count": m
    });
    //}
    return n.attr({
        "data-id": e,
        "data-value": encodeURIParamValue("collection" == d ? c.split(":")[0] : c),
        "data-parent-label": f,
        "data-title": l,
        "data-count": m
    }),
    this.getSettingValue("general.enableSeo") && "collection" != d && n.children().attr("rel", "nofollow"),
    "collection" == d && n.children().attr("data-collection-scope", i.key),
    jQ(n)[0].outerHTML
}

function __internalChange(event, target) {
  var targetOption = jQ(target).find(':selected');
    jQ(target).attr({
      "data-id": targetOption.attr('data-id'),
      "data-value": targetOption.attr('data-value'),
      "data-parent-label": targetOption.attr('data-parent-label'),
      "data-title": targetOption.attr('data-title'),
      "data-count": targetOption.attr('data-count')
    });
    target.onchange = null;
    jQ(target).attr('onchange',targetOption.attr('data-click'));
    jQ(target).trigger('change');
}

    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''&&data.variants){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
